import DescBlock from '@/layouts/game-settings/components/DescBlock'
import { FieldGroup, ImageUploaderSkeleton, PageHeader } from '@/ui'
import { Trans, useTranslation } from 'react-i18next'
import { Button, Skeleton } from '@dashboard/ui'

export const CompanySettingsFormSkeleton = () => {
  const { t } = useTranslation()
  return (
    <div>
      <PageHeader
        variant="bordered"
        sticky={true}
        extra={
          <Button size="sm" disabled={true}>
            {t('Save')}
          </Button>
        }
      >
        {t('company-settings-page.title')}
      </PageHeader>

      <div style={{ maxWidth: '1164px' }} className="mx-auto mt-5 flex w-full max-w-[1164px] flex-col gap-12">
        <DescBlock
          title={t('company-settings-page.general')}
          description={<Trans i18nKey="company-settings-page.general.desc" />}
        >
          <div>
            <FieldGroup label={<Skeleton className="h-[17px] w-1/3" />}>
              <Skeleton className="h-9 w-full" />
            </FieldGroup>

            <FieldGroup label={<Skeleton className="h-[17px] w-1/4" />}>
              <Skeleton className="h-9 w-full" />
            </FieldGroup>

            <FieldGroup label={<Skeleton className="h-[17px] w-2/4" />}>
              <ImageUploaderSkeleton />
            </FieldGroup>
          </div>
        </DescBlock>

        <DescBlock
          title={t('company-settings-page.domains')}
          description={<Trans i18nKey="company-settings-page.domains.desc" components={{ b: <b /> }} />}
        >
          <div>
            <FieldGroup>
              <Skeleton className="h-9 w-full" />
            </FieldGroup>
            <FieldGroup>
              <Skeleton className="h-7 w-1/4" />
            </FieldGroup>
          </div>
        </DescBlock>

        <DescBlock
          title={t('company-settings-page.viewer_domains')}
          description={<Trans i18nKey="company-settings-page.viewer_domains.desc" components={{ b: <b /> }} />}
        >
          <div>
            <FieldGroup>
              <Skeleton className="h-9 w-full" />
            </FieldGroup>
            <FieldGroup>
              <Skeleton className="h-7 w-1/4" />
            </FieldGroup>
          </div>
        </DescBlock>
      </div>
    </div>
  )
}
